import React from 'react';

import { CustomerData } from '@/sections/customerManagement/types';
import Avatar from '@/sections/topNavBar/Avatar';
import { useAuth } from '@/state/auth';

interface CustomerNameWithLogoProps {
  customer: CustomerData;
}

export const CustomerNameWithLogo: React.FC<CustomerNameWithLogoProps> = ({
  customer,
}) => {
  const { isPraetorianUser } = useAuth();
  const displayName = customer.displayName || customer.email;

  return (
    <div className="flex items-center gap-3">
      <div className="size-8 flex-shrink-0">
        <Avatar
          email={customer.email}
          className="size-8 rounded-full object-cover"
        />
      </div>
      <div className="flex min-w-0 flex-col">
        <span className="text-chariot-text-primary truncate text-sm font-medium">
          {displayName}
        </span>
        {isPraetorianUser && (
          <span className="text-chariot-text-secondary truncate text-xs">
            {customer.email}
          </span>
        )}
      </div>
    </div>
  );
};
